import { PickersLocaleText, deDE, enUS, nlNL } from '@mui/x-date-pickers'
import { useCustomTranslation } from './useCustomTranslation'

/**
 * Hook to get the locales for date picker components according to the selected app language
 */
export const useDatePickerLanguages = (): Partial<PickersLocaleText<unknown>> => {
  const { selectedAppLanguage } = useCustomTranslation()

  const languageMap: { [key: string]: Partial<PickersLocaleText<unknown>> } = {
    de: deDE.components.MuiLocalizationProvider.defaultProps.localeText,
    en: enUS.components.MuiLocalizationProvider.defaultProps.localeText,
    nl: nlNL.components.MuiLocalizationProvider.defaultProps.localeText,
  }

  return languageMap[selectedAppLanguage] ?? deDE
}
